import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ReportSearchHeaderWrapper = styled.div`
  margin: 4px 0px 16px;
  .header-left {
    .info-box-wrapper {
      padding-bottom: 0;
    }
  }
  .header-right {
    text-align: end;
    margin-top: 16px;

    .header-right-button {
      ${responsive.MOBILE`
        width:100%;
        margin-bottom:16px;
      `}
    }
  }
  .subtitle {
    display: flex;
    align-items: center;
    column-gap: 8px;
    margin-left: 8px;

    ${responsive.MOBILE`
      justify-content: space-between;
    `}
    .btn-secondary {
      height: auto;
      padding: 6px 8px;
      border-radius: 4px;
      border-color: ${COLORS.cirrus_black4};
    }
    .MuiTypography-h3SemiBold {
      max-width: 48%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
`;
